import { HttpService } from './common/HttpService';
import { EtaShareApi } from './domains/EtaShare';

class ApiService {
    private _httpService: HttpService;
    private _shareEtaApi?: EtaShareApi;

    constructor() {
        this._httpService = new HttpService();
    }

    etaShare() {
        if (!this._shareEtaApi) {
            this._shareEtaApi = new EtaShareApi(this._httpService);
        }
        return this._shareEtaApi;
    }
}

export { ApiService };
